import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import './style.css'

// Import views
import DashboardView from './views/DashboardView.vue'
import ChartsView from './views/ChartsView.vue'
import SymbolDetailView from './views/SymbolDetailView.vue'
import PositionsView from './views/PositionsView.vue'
import BlacklistView from './views/BlacklistView.vue'
import TokenView from './views/TokenView.vue'

// Import LoginView
import LoginView from './views/LoginView.vue'

// Router configuration
const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/login', component: LoginView, name: 'login' },
        { path: '/', component: PositionsView, name: 'positions' },
        { path: '/symbols', component: DashboardView, name: 'symbols' },
        { path: '/charts', component: ChartsView, name: 'charts' },
        { path: '/blacklist', component: BlacklistView, name: 'blacklist' },
        { path: '/token', component: TokenView, name: 'token' },
        { path: '/symbol/:id', component: SymbolDetailView, name: 'symbol-detail' }
    ]
})

// Auth guard
import { isAuthenticated } from './lib/auth'

router.beforeEach((to, from, next) => {
    // Allow access to login page without authentication
    if (to.name === 'login') {
        next()
        return
    }

    // Check if user is authenticated
    if (!isAuthenticated()) {
        // Redirect to login page
        next({ name: 'login' })
    } else {
        next()
    }
})

// Theme detection and application
const applyTheme = () => {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        document.documentElement.classList.add('dark')
    } else {
        document.documentElement.classList.remove('dark')
    }
}

// Apply theme on load
applyTheme()

// Watch for theme changes
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', applyTheme)

// Create Vue app
const app = createApp(App)
app.use(router)
app.mount('#app')
